import React from "react"
import { Form, Input } from "antd"
import getSlug from "speakingurl"
import useCommonQueries from "./useCommonQueries"

const MAX_SEO_TITLE_LENGTH = 60
const MAX_SEO_DESCRITPION_LENGTH = 158
const MAX_SEO_SLUG_LENGTH = 60

const useSeoFormItems = ({ form, itemId }) => {
  const { slugExists } = useCommonQueries()
  return (
    <>
      <Form.Item
        label="Titolo"
        name={["seo", "title"]}
        rules={[{ max: MAX_SEO_TITLE_LENGTH }, { required: true }]}
      >
        <Input showCount maxLength={MAX_SEO_TITLE_LENGTH} />
      </Form.Item>
      <Form.Item hidden noStyle name={["seo", "item_type"]}>
        <Input />
      </Form.Item>
      <Form.Item
        label="Descrizione"
        name={["seo", "description"]}
        rules={[{ max: MAX_SEO_DESCRITPION_LENGTH }, { required: true }]}
      >
        <Input.TextArea showCount maxLength={MAX_SEO_DESCRITPION_LENGTH} />
      </Form.Item>
      <Form.Item
        label="Slug"
        name={["seo", "slug"]}
        rules={[
          {
            max: MAX_SEO_SLUG_LENGTH,
          },
          { required: true },
          {
            validator: async (rule, value) => {
              try {
                const itemType = form.getFieldsValue().seo?.item_type
                const _slugExists = await slugExists(value, itemId, itemType)
                if (_slugExists) {
                  throw new Error("Slug presente")
                }
              } catch (err) {
                throw err
              }
            },
          },
        ]}
      >
        <Input
          showCount
          maxLength={MAX_SEO_SLUG_LENGTH}
          onBlur={evt => {
            const allValues = form.getFieldsValue()
            allValues.seo.slug = getSlug(form.getFieldValue(["seo", "slug"]))
            form.setFieldsValue(allValues)
          }}
        />
      </Form.Item>
    </>
  )
}

export default useSeoFormItems
